import { ReactComponent as SpinnerSvg } from '../assets/spinner.svg';

export const Spinner: React.FC<{ size?: number }> = ({ size = 24 }) => {
  return <SpinnerSvg width={24} height={24} className="animate-spin direction-reverse" />;
};
